export const BODY = 'body';
export const VIEWPORT = 'viewport';
